var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "staffScrollbar", staticClass: "scroll-box" }, [
    _vm.pageInfo.totals == 0 && !_vm.loading
      ? _c(
          "div",
          { staticClass: "chat-complate", staticStyle: { height: "100%" } },
          [_c("span", { staticClass: "empty-text" }, [_vm._v("暂无数据")])]
        )
      : _vm._e(),
    _c("div", {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      attrs: {
        id: "new-conversation-iframe-container",
        "element-loading-text": "拼命加载中..."
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }